

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    courseCard1Object = { no:1, 
    id: generateTimestamp()+3,
    cardName:"LeadInfoCard1",
    cardType:"editable",
    myKey:`id-LeadInfoCard1-layout`,
    compact:{status:false},
    layoutCard:{
            layoutBG:{title:"Layout  Card Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            borderCard:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(230, 252, 248, 1)",colors:{},alpha:1}},
           borderRadius:{title:"Lead Card Button Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
         
                     },
      cardTheme:{
      cardThemeBG:{title:"PopUp Card BG Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
                },
     courseTitle:{
             titleColor:{title:"Title Color",color:"rgba(23, 23, 23, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
             subtitleColor:{title:"Subtitle  & Icon Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
             buttonColor:{title:"Button  Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
            
             tagsColor:{title:"Tag Text Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
             metaColor:{title:" Label Color",color:"rgba(77, 80, 76, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
             titleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               subtitleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               metaFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }
               },
           
          showMoreBtn:{  title:"Show More",
          btnColor:{title:" Show More Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:4,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:150,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
                },
          
          
         buyNowBtn:{ title:"Buy Now",
         btnBG:{title:" Buy/Enroll Button Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         btnColor:{title:"Buy/Enroll Button Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Buy/Enroll Button Radius",
         topLeft:{title:"Top Left Radius",value:150,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
       
              },
           enrollBtn:{ title:"Enroll",
          
              },
          
          
        wishListCartBtn:{
           
           btnColor:{title:"Cart Wishlist Button Color",color:"rgba(224, 246, 251, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           iconColor:{title:"Cart Wishlist Icon Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
           border:{title:"Cart  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
           borderRadius:{title:"Lead Card Button Radius",
           topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
           topRight:{title:"Top Right Radius",value:10,resolution:"px"},
           bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
           bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
          
             },

        tags:{
             buttonBG:{title:"Tag Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)",color1:"rgba(144, 202, 249,0.71)",},alpha:1},
             border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:1,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
            
             borderRadius:{title:"Lead Card Button Radius",
             topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
             topRight:{title:"Top Right Radius",value:10,resolution:"px"},
             bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
             bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
           
                
             },
          
          
            
       
         image: {   
                  status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg",
                  s3Key:"",
         aspectRatio:{title:"Image Crop Ratio",value:"2/1"},
         borderRadius:{title:"Lead Card Image Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
         borderImage:{title:"Image  Border",borderType:"double",
         borderWidth:{title:"Border Width",value:25,resolution:"px"}
        ,borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         },

        
      popUpCourse:{
      cardBG:{title:"PopUp Card BG Color",color:"rgba(250, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
      border:{title:"PopUp  Border",borderType:"solid",borderWidth:{title:"Border Width",value:4,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
      borderRadius:{title:"PopUp Radius",
             topLeft:{title:"Top Left Radius",value:20,resolution:"px"},
             topRight:{title:"Top Right Radius",value:10,resolution:"px"},
             bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
             bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}},
            },
     whatWillWeLearn:{},
     prerequisite:{},
     targetAudience:{},
     faqs:{},
     highlights:{},
      
     visibleItems:{
        image:true,
        tags:true,
        buyNowBtn:true,
        wishListBtn:true,
        enrollBtn:true,
        priceText:true,
        title:true,
        subtitle:true,
        author:true,
        ratings:true,
        contents:true,
        progress:true,
        popUpItems:{
        whatWillWeLearn:true,
        prerequisite:true,
        targetAudience:true,
        skills:true,
        language:true,
        faqs:true,
        highlights:true

        }
      }
        


            
     
                       
         
        }